// TODO: Remove references to this, then remove this - just reference the class itself
export interface IColors {
  aptTan: string;
  aptYellow: string;
  aptLightOrange: string;
  aptOrange: string;
  aptRed: string;

  aptLightGreen: string;
  aptMidGreen: string;
  aptGreen: string;
  aptGrayGreen: string;
  aptDarkGreen: string;

  aptBlue: string;
  aptDarkBlue: string;

  aptPink: string;

  aptWhite: string;
  aptLightGray: string;
  aptMidGray: string;
  aptDarkGray: string;
  aptOffBlack: string;
  aptBlack: string;
}

export default class Colors {
  // Update _aptitude-core-constants.scss when updating this
  aptTan = '#e7d8ac';
  aptYellow = '#fdbb30';
  aptLightOrange = '#fce8c8';
  aptOrange = '#e36f1e';
  aptRed = '#ff0000';

  aptLightGreen = '#eef5e4';
  aptMidGreen = '#b2d78c';
  aptGreen = '#8dc63f';
  aptGrayGreen = '#95a696';
  aptDarkGreen = '#00853f';

  aptBlue = '#0093d0';
  aptDarkBlue = '#005596';

  aptPink = '#ed1f79';

  aptWhite = '#fff';
  aptLightGray = '#f2f2f2';
  aptMidGray = '#cececf';
  aptDarkGray = '#4e4d4f';
  aptOffBlack = '#343739';
  aptBlack = '#000';
}
